import { ex } from "@fullcalendar/core/internal-common";

// Campaign step types and interfaces
export interface FormValues {
  name: string;
  subject: string;
  emailContext: string;
  answers: Array<{
    questionText: string;
    answerText: string;
  }>;
  coldEmail?: {
    coldEmailContent: string;
    coldEmailRepeat: number;
    coldEmailLimit: number;
  };
}

export interface StepProps {
  formik: any;
  onNext: () => void;
  onPrevious: () => void;
  currentStep: number;
  buttonName: string;
  isView?: boolean;
}

export interface QuestionStepProps extends StepProps {
  questionAnswer: any[];
  questionIndex: number;
  showErrorForm: boolean;
  setShowErrorForm: (show: boolean) => void;
  isView: boolean;
}

export interface ContactStepProps extends StepProps {
  totalContacts: number;
  filteredContact: any[];
  contactsSelected: any[];
  selectAll: boolean;
  showErrorSelectContact: boolean;
  hasMore: boolean;
  loadingContacts: boolean;
  saleRepOptions: any[];
  contactsTemp: any[];
  channelType: string | "";
  onLoadMore: () => void;
  handleContactSearch: (searchData: {
    searchValue: string;
    zipCode: string;
    range: string;
    status: string[];
    saleRep: string[];
  }) => void;
  handleSelectAll: () => void;
  handleContactSelect: (contact: any) => void;
  setShowErrorSelectContact: (show: boolean) => void;
}

export interface ReviewStepProps extends StepProps {
  emailTemplate: string;
  sanitizedTemplate: string;
  isEditing: boolean;
  waitingReGenerateTemplate: boolean;
  isSubjectChanged: boolean;
  currentSubject: any;
  channelType: string | "";
  setIsEditing: (editing: boolean) => void;
  handleReGenerateTemplate: () => void;
  handleSaveTemplate: (content: string) => void;
  setIsSubjectChanged: (changed: boolean) => void;
  onContentChange: (hasChanged: boolean) => void;
}

export interface ConfirmationStepProps extends StepProps {
  contactsSelected: any[];
  sanitizedTemplate: string;
  channelType: string | "";
}

export interface SendingStepProps {
  sendingEmail: boolean;
}

export enum ChannelType {
  Email = "Email",
  SMS = "SMS",
  EmailAndSMS = "Email and SMS",
  EmailMarketing = "Email Marketing",
}

export enum CampaignType {
  ReEngagement = 1,
  RequestForReview = 2,
  ColdEmailOutreach = 3,
}

export enum CampaignTypeText {
  ReEngagement = "Re-engagement",
  RequestForReview = "Request for review",
  ColdEmailOutreach = "Cold email outreach",
}

export enum MetaData {
  Topic = "Topic",
  Limit = "Limit",
  RepeatFrequency = "RepeatFrequency",
  EmailsSendingTime = "EmailsSendingTime",
}

export enum CampaignQuestionType {
  Type = "What type of campaign strategies?",
  Long = "How long should the email be?",
  Tone = "What is email tone?",
  Channel = "Choose channel for the campaign",
}
